var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.value && _vm.type === 'date')?_c('human-date',{attrs:{"date":_vm.parseDate(_vm.value)}}):[_vm._v(_vm._s(_vm.renderValue))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }